import { combine, createEvent, createStore, sample } from 'effector'
import { persist } from 'effector-storage/local'
import { model as session } from '~/entities/session'
import { noop } from '~/shared/effector'

export const setIsDolbyAtmosPreferred = createEvent<{ value: boolean }>()
const $isDolbyAtmosPreferred = createStore<Record<string, boolean>>({})

sample({
  clock: setIsDolbyAtmosPreferred,
  source: {
    session: session.$session,
    isDolbyAtmosPreferred: $isDolbyAtmosPreferred,
  },
  filter: ({ session }) => session != null,
  fn: ({ session, isDolbyAtmosPreferred }, { value }) => ({
    ...isDolbyAtmosPreferred,
    [session!.accountNumber]: value,
  }),
  target: $isDolbyAtmosPreferred,
})

export const $currentDolbyAtmosPreferred = combine(
  $isDolbyAtmosPreferred,
  session.$session,
  (isDolbyAtmosPreferred, session) => {
    const accountNumber = session?.accountNumber
    if (!accountNumber) return false
    return isDolbyAtmosPreferred[accountNumber] || false
  }
)

// we do not use scopes for now, so, ignore this rule
// eslint-disable-next-line effector/require-pickup-in-persist
persist({
  store: $isDolbyAtmosPreferred,
  key: 'tria__is_dolby_atmos_preferred',
  fail: noop,
})
